<div class="cards-wrapper">
  <rappider-cards [items]="homeCardsConfig?.cardsConfig?.items!"
                  [itemCountPerRow]="homeCardsConfig?.cardsConfig?.itemCountPerRow!"
                  [showTitleOnImage]="homeCardsConfig?.cardsConfig?.showTitleOnImage!"
                  [showDescriptionOnImage]="homeCardsConfig?.cardsConfig?.showDescriptionOnImage!"
                  [selectConfig]="homeCardsConfig?.cardsConfig?.selectConfig!"
                  [paginationConfig]="homeCardsConfig?.cardsConfig?.paginationConfig!"
                  [showCheckMarkOnCard]="homeCardsConfig?.cardsConfig?.showCheckMarkOnCard!"
                  [inputGroupConfig]="homeCardsConfig?.cardsConfig?.inputGroupConfig"
                  [clickedCardId]="selectedModelCardId!"
                  (cardDetail)="onCardDetailClicked($event)"
                  (imageButtonClick)="onCardSelected($event)"></rappider-cards>
</div>
